// MF-568 — Small pieces shared by the PAT class cards: the group-size line, the "stanine not configured" note,
// the interpretation footnote and the roster of the selected teaching group.
import { Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../boardTheme'
import { fmtDay, INTERPRETATION, STANINE_NOTE } from './patShared'
import { DetailCard, DetailTable } from './PatDetail'

export const GroupLine = ({ n, excluded = 0, noStanine = 0, extra }) => (
  <Typography sx={{ fontSize: 12, color: SUMMARY_PALETTE.muted }}>
    <b>n = {n}</b>
    {excluded > 0 ? ` · ${excluded} excluded (no score)` : ''}
    {noStanine > 0 ? ` · ${noStanine} without stanine` : ''}
    {extra ? ` · ${extra}` : ''}
  </Typography>
)

export const StanineNote = () => (
  <Typography role='note' sx={{ fontSize: 12, color: SUMMARY_PALETTE.bad, mt: 0.5 }}>
    N/A: {STANINE_NOTE}
  </Typography>
)

export const Interpretation = () => (
  <Typography sx={{ fontSize: 11, color: SUMMARY_PALETTE.faint, mt: 1.5 }}>{INTERPRETATION}</Typography>
)

/** The selected group: name, exact score, stanine and test date, as a clean card under the chart. */
export const Roster = ({ students, label, onClear }) => {
  if (!students.length) return null
  return (
    <DetailCard title={label || 'Selected group'} count={students.length} onClear={onClear}>
      <DetailTable
        rowKey={(s) => s.id}
        rows={students}
        columns={[
          { key: 'name', label: 'Student', wrap: true },
          { key: 'score', label: 'Score', align: 'right', bold: true },
          {
            key: 'stanine',
            label: 'Stanine',
            align: 'right',
            render: (s) => (s.stanine === null ? 'N/A' : s.stanine)
          },
          { key: 'test_date', label: 'Tested', muted: true, render: (s) => fmtDay(s.test_date) }
        ]}
      />
    </DetailCard>
  )
}
